"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductItemAttributesFullSchema = void 0;
const zod_1 = require("zod");
const image_1 = require("../common/image");
const pricing_rate_1 = require("../common/pricing_rate");
const product_item_1 = require("../common/product_item");
const product_variant_1 = require("../common/product_variant");
exports.ProductItemAttributesFullSchema = product_item_1.ProductItemAttributesSchema.merge(zod_1.z.object({
    Images: zod_1.z.array(image_1.ImageAttributesSchema).nullable().optional(),
    PricingRates: zod_1.z.array(pricing_rate_1.PricingRateAttributesSchema).nullable().optional(),
    ProductVariants: zod_1.z
        .array(product_variant_1.ProductVariantAttributesSchema)
        .nullable()
        .optional(),
}));
//# sourceMappingURL=product_item_full.js.map